const state = {
  lenders: [],
  matchedLenders: [],
}

const mutations = {
  GET_MATCHED_LENDERS (state, matchedLenders) {
    state.matchedLenders = matchedLenders
  },
  CLEAR_MATCHED_LENDERS (state) {
    state.matchedLenders = []
  },
  SET_LENDERS (state, lenders) {
    state.lenders = lenders
  },
}

const actions = {
  setMatchedLenders (context, payload) {
    context.commit('GET_MATCHED_LENDERS', payload)
  },
  clearMatchedLenders (context) {
    context.commit('CLEAR_MATCHED_LENDERS')
  },
  setLenders (context, payload) {
    context.commit('SET_LENDERS', payload)
  },
}

const getters = {
  //
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
